module.exports = __webpack_public_path__ + "img/img_17.bc4b7831.svg";